import React, { useEffect, useMemo } from 'react'
import { Box, Typography } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { SingleToggleSettingBox } from 'src/Elements/SystemSettings/forms'
import { useField, useFormikContext } from 'formik'
import { isUndefined } from 'lodash'
import SettingsBox from 'src/Elements/Data/SettingsBox'
import { NumberField } from 'src/Libs/inputs/formik'
import { LoadingPriorisationFormModel } from 'src/Libs/wallboxes/models'

interface Props {
  hasWritingAccess: boolean
}

const LoadingPrioritizationFormData: React.VFC<Props> = ({ hasWritingAccess }) => {
  const { setFieldValue } = useFormikContext<LoadingPriorisationFormModel>()
  const [isBatteryField] = useField<boolean>('isBattery')
  const [inSunModeField] = useField<boolean>('inSunMode')
  // const [tillSocField] = useField<boolean>('tillSoc')
  const { t } = useCustomTranslation()
  const isSuModeChangeable = useMemo(() => !isUndefined(isBatteryField.value) && !isBatteryField.value, [isBatteryField.value])
  const isTillSocChangeable = useMemo(() => !isUndefined(inSunModeField.value) && inSunModeField.value, [inSunModeField.value])

  useEffect(() => {
    if (isUndefined(isBatteryField.value)) {
      return
    }

    if (isBatteryField.value) {
      setFieldValue('inSunMode', false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBatteryField.value])
  return (
    <Box>
      <Typography variant="body1" sx={{ mb: 2 }}>
        {t('systemSettings.wallbox.settings.loadingPrio.introduction')}
      </Typography>
      <SingleToggleSettingBox
        name="isBattery"
        title={t('systemSettings.wallbox.settings.loadingPrio.prio.label')}
        trueLabel={t('systemSettings.wallbox.settings.loadingPrio.prio.batteryFirst')}
        falseLabel={t('systemSettings.wallbox.settings.loadingPrio.prio.wallboxFirst')}
        disabled={!hasWritingAccess}
        fullWidth
      />
      <Typography variant="h3" sx={{ mb: 2, mt: 4 }}>
        {t('systemSettings.wallbox.settings.loadingPrio.discharge.title')}
      </Typography>
      <SingleToggleSettingBox
        name="inSunMode"
        disabled={!isSuModeChangeable || !hasWritingAccess}
        title={t('systemSettings.wallbox.settings.loadingPrio.inSunMode.label')}
        trueLabel={t('systemSettings.wallbox.settings.loadingPrio.inSunMode.option1')}
        falseLabel={t('systemSettings.wallbox.settings.loadingPrio.inSunMode.option2')}
        fullWidth
      />
      <SettingsBox
        disabled={!hasWritingAccess}
        title={t('systemSettings.wallbox.settings.loadingPrio.tillSoc.label')}
        suffix={<NumberField disabled={!isTillSocChangeable || !hasWritingAccess} fullWidth={false} name="tillSoc" suffix={'%'} />}
      />
      <SingleToggleSettingBox
        name="inMixMode"
        title={t('systemSettings.wallbox.settings.loadingPrio.inMixMode.label')}
        trueLabel={t('systemSettings.wallbox.settings.loadingPrio.inMixMode.option1')}
        falseLabel={t('systemSettings.wallbox.settings.loadingPrio.inMixMode.option2')}
        disabled={!hasWritingAccess}
        fullWidth
      />
    </Box>
  )
}

export default LoadingPrioritizationFormData
